<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Tagihan External Belum Lunas</v-card-title>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.tgl_tagihan="{ item }">
          {{ formatDate(item.tgl_tagihan) }}
        </template>
        <template v-slot:item.nilai_tagihan="{ item }">
          {{ formatCurrency(item.nilai_tagihan) }}
        </template>
        <template v-slot:item.tgl_jatuh_tempo="{ item }">
          <span :class="{ 'red--text': isOverdue(item.tgl_jatuh_tempo) }">
            {{ formatDate(item.tgl_jatuh_tempo) }}
          </span>
        </template>
      </v-data-table>

      <v-card class="mt-2 pa-3" tile v-if="data.length > 0">
        <strong>Total Belum Lunas: {{ formatCurrency(totalBelumLunas) }}</strong>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { formatDateOnly, parseDateOnly } from "@/util/helpers";

export default {
  name: "TagihanExtBelumLunas",
  data() {
    return {
      loading: {
        fetchData: false
      },
      dataHeaders: [
        { text: "POS", value: "pos" },
        { text: "Nama Penagih", value: "nama_penagih" },
        { text: "No Rekening", value: "no_rekening" },
        { text: "Tgl Tagihan", value: "tgl_tagihan" },
        { text: "No Tagihan", value: "no_tagihan" },
        { text: "Keterangan", value: "keterangan_tagihan" },
        { text: "Nilai", value: "nilai_tagihan" },
        { text: "Jatuh Tempo", value: "tgl_jatuh_tempo" }
      ],
      data: []
    };
  },
  computed: {
    totalBelumLunas() {
      return this.data.reduce((sum, item) => sum + (Number(item.nilai_tagihan) || 0), 0);
    }
  },
  methods: {
    formatCurrency(val) {
      if (!val) return "0";
      return Number(val).toLocaleString("id-ID");
    },
    formatDate(date) {
      return formatDateOnly(date);
    },
    isOverdue(date) {
      if (!date) return false;
      const dateValue = parseDateOnly(date);
      if (!dateValue) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return dateValue < today;
    },
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`tagihan-external/belum-lunas`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response?.data?.message || "Gagal memuat tagihan belum lunas");
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
